/**
 * Extract locality (e.g. Kondapur, Kollur) from a full address string.
 * Indian-style addresses often look like: "..., Area, Locality, City, State Pin, Country"
 * We return the part immediately before the city when city is provided; otherwise a fallback.
 *
 * @param {string} address - Full address e.g. "FC86+CC8, Bhavani Nagar, Hitech City, Kondapur, Hyderabad, Telangana 500018, India"
 * @param {string} [city] - City name e.g. "Hyderabad" to find locality before it
 * @returns {string} Locality name (e.g. "Kondapur") or empty string
 */
export function getLocalityFromAddress(address, city = '') {
  if (!address || typeof address !== 'string') return '';
  const parts = address.split(',').map((s) => s.trim()).filter(Boolean);
  if (parts.length === 0) return '';

  const cityNorm = (city || '').trim().toLowerCase();
  if (cityNorm) {
    const cityIndex = parts.findIndex((p) => p.toLowerCase() === cityNorm);
    if (cityIndex > 0) return parts[cityIndex - 1];
  }

  if (parts.length >= 2) return parts[parts.length - 2];
  return parts[0] || '';
}
